<template>
  <div class="diagram-frequency-sec">
    <p class="diagram-frequency-sec__title">
      {{ title }}
    </p>
    <p
      v-for="(frequency,frequencyIndex) in _frequencySec"
      :key="frequencyIndex"
      class="diagram-frequency-sec__text"
    >
      {{ frequency }}{{ unit }}
    </p>
  </div>
</template>
<script>
export default {
  name: "DiagramFrequencySec",
  props: {
    frequencyRange: {
      type: Array,
      default() {
        return [];
      },
    },
    unit: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default() {
        return this.$t("時間");
      },
    },
    max: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    _frequencySec() {
      let frequencySec = [];
      let remainder =
        (this.frequencyRange[0] - this.frequencyRange[1]) % this.max;
      let maxRange =
        remainder > 0
          ? this.frequencyRange[0] + (this.max - remainder)
          : this.frequencyRange[0];
      let gap = (maxRange - this.frequencyRange[1]) / this.max;
      for (let i = 0; i < this.max + 1; i++) {
        let frequency = maxRange - i * gap;
        frequencySec.push(frequency);
      }
      return frequencySec;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diagram-frequency-sec";
</style>